import React from 'react';
import styles from './ContactPopup.module.css';
import user_image_placeholder from '../../../../../assets/images/other/user_avatar_placeholder.png';
import { exists } from './utils';

/**
 * ProfileImage Component
 * Displays user profile image with fallback to placeholder
 * 
 * @param {Object} props - Component props
 * @param {string} props.profileImage - Profile image path
 * @param {boolean} props.hideProfilePicture - Whether profile picture should be hidden
 * @param {string} props.firstName - User's first name
 * @param {string} props.lastName - User's last name
 * @param {string} props.uploadsPath - Path to uploaded images
 * @returns {JSX.Element} - Rendered component
 */
const ProfileImage = ({ profileImage, hideProfilePicture, firstName, lastName, uploadsPath }) => {
    // Always show placeholder if no profile image or if hidden
    if (hideProfilePicture || !exists(profileImage)) {
        return (
            <div className={styles.profileImageLarge}>
                <img src={user_image_placeholder} alt="Profile" />
            </div>
        );
    }
    
    // Show actual image with fallback to placeholder
    return (
        <div className={styles.profileImageLarge}>
            <img 
                src={uploadsPath + profileImage} 
                alt={`${exists(firstName) ? firstName : ''} ${exists(lastName) ? lastName : ''}`} 
                onError={(e) => {
                    e.target.src = user_image_placeholder;
                }}
            />
        </div>
    );
};

export default ProfileImage; 